const VISIBLE_CLASS = 'traffic-block--visible';

export const initTraffic = () => {
  const $switch = $('[name="traffic"]');
  const $geoBlock = $('.traffic-geo');
  const $geoBg = $('.traffic-geo-bg');
  const $typeBg = $('.traffic-type-bg');
  const $geoAosItems = $geoBlock.find('[data-aos]');
  const $typeBlock = $('.traffic-type');
  const $typeAosItems = $typeBlock.find('[data-aos]');
  const container = document.getElementById('traffic');

  $switch.on('change', function (e) {
    const activeType = $(this).val();

    if (activeType === 'geo') {
      $typeBlock.css('display', 'none').removeClass(VISIBLE_CLASS);
      $geoBlock.stop().fadeIn(1500).addClass(VISIBLE_CLASS);
      $typeBg.css('display', 'none').removeClass('visible aos-animate aos-init').removeAttr('data-aos');
      $geoBg.stop().fadeIn(1200).addClass('visible');
      // $geoAosItems.removeClass('aos-animate').addClass('aos-init').setAttribute('data-aos', 'fade-in');
      // $typeBg.removeClass('visible').setAttribute('data-aos', 'fade-in');
      // $geoBg.removeClass('aos-animate').addClass('visible aos-init').setAttribute('data-aos', 'fade-in');
      // setTimeout(() => {
      //   $geoAosItems.addClass('aos-animate');
      //   $geoBg.addClass('aos-animate');
      // },100);
      if ($(document).width() < 980) {
        container.scrollIntoView({block: 'start'})
      }
    } else {
      $geoBlock.css('display', 'none').removeClass(VISIBLE_CLASS);
      $geoBg.css('display', 'none').removeClass('visible aos-animate aos-init').removeAttr('data-aos');
      $typeBlock.stop().fadeIn(1500).addClass(VISIBLE_CLASS);
      $typeBg.stop().fadeIn(1200).addClass('visible');
      // $typeAosItems.removeClass('aos-animate').addClass('aos-init').setAttribute('data-aos', 'fade-in');
      // $geoBg.removeClass('visible').setAttribute('data-aos', 'fade-in');
      // $typeBg.removeClass('aos-animate').addClass('visible aos-init').setAttribute('data-aos', 'fade-in');
      // setTimeout(() => {
      //   $typeAosItems.addClass('aos-animate');
      //   $typeBg.addClass('aos-animate');
      // }, 100)
    }
  });
}
